import PageLayout from '../components/layout/PageLayout'
import FloatingFabs from '@astro/floating-fabs'
import GalleryHeroSection from '../components/sections/gallery/GalleryHeroSection'
import GalleryMasonrySection from '../components/sections/gallery/GalleryMasonrySection'
import NewsletterSection from '../components/sections/newsletter/NewsletterSection'

export default function GalleryPage() {
  return (
    <PageLayout className="bg-[#403c3d]/5 text-[#151b21] antialiased min-h-screen flex flex-col">
      <main className="grow">
        <GalleryHeroSection />
        <GalleryMasonrySection />
        {/* <NewsletterSection /> */}
      </main>
      <FloatingFabs />
    </PageLayout>
  )
}
